import SkipContentLink from './SkipContentLink';

export default SkipContentLink;
